(function () {
    //Set default value in case of null,undefined or ""
    angular.module('tmx-app').filter('defaultValue', [function () {
        return function (value, leaveZero, def) {
            if(!leaveZero) leaveZero = false;
            if(!def) def = 'N/A';
            return (leaveZero && value === 0) ? value : (value || def);
        };
    }]);
})();